import { createTransaction } from '../api-wfp/services';
import { TransactionData } from '../entities';

export async function getTransactionData(amount: number, submissionId?: string) {
    return await createTransaction(amount, submissionId).then((res) => {
        const transationData = new TransactionData(res);
        return transationData;
    });
}
